'use client';
var isHex = function(raw) {
    return /^#([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(raw);
};
var isRGB = function(raw) {
    return /^rgb\((.+)\)$/i.test(raw);
};
var isRGBA = function(raw) {
    return /^rgba\((.+)\)$/i.test(raw);
};
var isCssVariable = function(raw) {
    return /^var\(--(.+)\)$/i.test(raw);
};
/* istanbul ignore next */ var isNonConvertibleColor = function(raw) {
    return isCssVariable(raw) || raw === "none";
};
var isConvertibleColor = function(raw) {
    return isHex(raw) || isRGBA(raw) || isRGB(raw) || raw === "transparent";
};
/* istanbul ignore next */ var isColorScalar = function(raw) {
    return isConvertibleColor(raw) || isNonConvertibleColor(raw);
};

export { isColorScalar, isConvertibleColor, isCssVariable, isHex, isNonConvertibleColor, isRGB, isRGBA };
